export default __webpack_public_path__ + "static/media/proj1.f30388e3.png";